/* snx-fx: tiny motion engine for the Side Carrier PDP variants. No libraries.
   --p 0..1 element travel through viewport, --c -1..1 (0 = centred), --s 0..1 progress inside a pinned (tall) block.
   Only elements on screen are updated, once per frame, transforms only. Respects reduced motion. */
(function(){
  if (window.__snxFx) return; window.__snxFx = 1;
  var d = document, R = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  R.classList.add(reduce ? 'fx-reduce' : 'fx-on');
  function ready(f){ if (d.readyState !== 'loading') f(); else d.addEventListener('DOMContentLoaded', f); }
  function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  ready(function(){
    var IO = 'IntersectionObserver' in window;
    /* 1. reveal on enter */
    var rv = d.querySelectorAll('.fx-r');
    if (IO && !reduce) {
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('fx-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      rv.forEach(function(el){ io.observe(el); });
    } else rv.forEach(function(el){ el.classList.add('fx-in'); });

    /* 2. word-by-word reading highlight */
    d.querySelectorAll('[data-fx-words]').forEach(function(el){
      var w = el.textContent.trim().split(/\s+/); el.textContent = ''; el.style.setProperty('--n', w.length);
      w.forEach(function(t, i){ var s = d.createElement('span'); s.className = 'fx-w'; s.style.setProperty('--i', i); s.textContent = t + (i < w.length - 1 ? ' ' : ''); el.appendChild(s); });
    });

    /* 3. scroll progress driver */
    var els = [].slice.call(d.querySelectorAll('[data-fx]')), live = [], tick = false, vh = innerHeight;
    function upd(){
      tick = false;
      for (var k = 0; k < live.length; k++){
        var el = live[k], r = el.getBoundingClientRect();
        var p = clamp((vh - r.top) / (vh + r.height));
        el.style.setProperty('--p', p.toFixed(4)); el.style.setProperty('--c', (p * 2 - 1).toFixed(4));
        if (el.hasAttribute('data-fx-pin')) { var span = r.height - vh; el.style.setProperty('--s', (span > 0 ? clamp(-r.top / span) : p).toFixed(4)); }
      }
    }
    function req(){ if (!tick){ tick = true; requestAnimationFrame(upd); } }
    if (!reduce && IO && els.length){
      var io2 = new IntersectionObserver(function(es){ es.forEach(function(e){ var i = live.indexOf(e.target); if (e.isIntersecting){ if (i < 0) live.push(e.target); } else if (i > -1) live.splice(i, 1); }); req(); }, { rootMargin: '15% 0px' });
      els.forEach(function(el){ io2.observe(el); });
      addEventListener('scroll', req, { passive: true });
      addEventListener('resize', function(){ vh = innerHeight; req(); }, { passive: true });
    } else els.forEach(function(el){ el.style.setProperty('--p', '.5'); el.style.setProperty('--c', '0'); el.style.setProperty('--s', '1'); });

    /* 4. pointer tilt (desktop only) */
    if (!reduce && matchMedia('(hover:hover) and (pointer:fine)').matches){
      d.querySelectorAll('[data-fx-tilt]').forEach(function(el){
        var max = parseFloat(el.getAttribute('data-fx-tilt')) || 6, raf = 0;
        el.addEventListener('pointermove', function(ev){
          var r = el.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5;
          cancelAnimationFrame(raf); raf = requestAnimationFrame(function(){ el.style.setProperty('--ry', (x * max).toFixed(2) + 'deg'); el.style.setProperty('--rx', (-y * max).toFixed(2) + 'deg'); });
        });
        el.addEventListener('pointerleave', function(){ el.style.setProperty('--ry', '0deg'); el.style.setProperty('--rx', '0deg'); });
      });
    }

    /* 5. count up */
    d.querySelectorAll('[data-fx-count]').forEach(function(el){
      var to = parseInt(el.getAttribute('data-fx-count'), 10); if (reduce || !IO) return;
      el.textContent = '1';
      var o = new IntersectionObserver(function(es){
        if (!es[0].isIntersecting) return; o.disconnect();
        var t0 = performance.now(), dur = 1300;
        (function f(t){ var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3); el.textContent = Math.max(1, Math.round(to * k)); if (k < 1) requestAnimationFrame(f); })(t0);
      }, { threshold: .5 });
      o.observe(el);
    });

    /* 6. steps <-> pins (scrollytelling, tiles) */
    d.querySelectorAll('[data-fx-scope]').forEach(function(sc){
      var steps = sc.querySelectorAll('[data-step]'), pins = sc.querySelectorAll('[data-pin]');
      function set(n){ sc.setAttribute('data-active', n); steps.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-step') === n); }); pins.forEach(function(p){ if (p.tagName !== 'DETAILS') p.classList.toggle('is-active', p.getAttribute('data-pin') === n); }); }
      if (sc.hasAttribute('data-fx-steps') && IO){
        var o = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) set(e.target.getAttribute('data-step')); }); }, { rootMargin: innerWidth < 990 ? '-64% 0px -30% 0px' : '-45% 0px -45% 0px' });
        steps.forEach(function(s){ o.observe(s); });
      }
      steps.forEach(function(s){ var n = s.getAttribute('data-step'); s.addEventListener('pointerenter', function(){ set(n); }); s.addEventListener('focusin', function(){ set(n); }); s.addEventListener('click', function(){ set(n); }); });
      pins.forEach(function(p){ if (p.tagName === 'DETAILS') return; p.addEventListener('click', function(){ var n = p.getAttribute('data-pin'); set(n); var t = sc.querySelector('[data-step="' + n + '"]'); if (t && sc.hasAttribute('data-fx-steps')) t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); });
      set(sc.getAttribute('data-active') || '1');
    });

    /* 7. 3D coverflow */
    d.querySelectorAll('[data-fx-cover]').forEach(function(sc){
      var items = sc.querySelectorAll('[data-cover-item]'), raf = 0, root = sc.closest('[data-fx-cover-root]') || sc.parentNode;
      function upd(){ raf = 0; var r = sc.getBoundingClientRect(), mid = r.left + r.width / 2;
        items.forEach(function(it){ var b = it.getBoundingClientRect(), o = ((b.left + b.width / 2) - mid) / b.width; o = Math.max(-1.6, Math.min(1.6, o)); it.style.setProperty('--o', o.toFixed(3)); it.classList.toggle('is-center', Math.abs(o) < .5); }); }
      function req2(){ if (!raf) raf = requestAnimationFrame(upd); }
      sc.addEventListener('scroll', req2, { passive: true }); addEventListener('resize', req2, { passive: true }); upd();
      var step = function(dir){ var w = items[0] ? items[0].getBoundingClientRect().width : 300; sc.scrollBy({ left: dir * w, behavior: 'smooth' }); };
      var pv = root.querySelector('[data-fx-prev]'), nx = root.querySelector('[data-fx-next]');
      if (pv) pv.addEventListener('click', function(){ step(-1); }); if (nx) nx.addEventListener('click', function(){ step(1); });
      if (sc.hasAttribute('data-fx-start-center') && items[1]) { sc.scrollLeft = items[1].offsetLeft - (sc.clientWidth - items[1].clientWidth) / 2; upd(); }
    });
  });
})();
